import { render, staticRenderFns } from "./AppLayoutMenu.vue?vue&type=template&id=494026e2"
import script from "./AppLayoutMenu.vue?vue&type=script&lang=js"
export * from "./AppLayoutMenu.vue?vue&type=script&lang=js"
import style0 from "./AppLayoutMenu.vue?vue&type=style&index=0&id=494026e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports